import { Link } from "react-router-dom";
import { Minus, Plus, X, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";
import { inr } from "../lib/api";
import { Overline } from "../components/Reveal";

export default function Cart() {
  const { items, updateQty, removeItem, subtotal } = useCart();

  return (
    <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-14 md:py-20" data-testid="cart-page">
      <Overline>Your Selection</Overline>
      <h1 className="font-serif text-5xl sm:text-6xl tracking-tighter mt-3">Cart.</h1>
      {items.length === 0 ? (
        <div className="py-24 text-center" data-testid="cart-empty">
          <p className="font-serif text-3xl text-muted-foreground">Your cart is empty.</p>
          <Link to="/shop" data-testid="cart-shop-btn" className="inline-block mt-8 bg-ink text-ivory px-8 py-4 text-[11px] tracking-[0.25em] uppercase hover:bg-wine transition-colors">Shop Collection</Link>
        </div>
      ) : (
        <div className="mt-12 grid lg:grid-cols-[1fr_360px] gap-14">
          <div className="divide-y divide-border border-t border-b border-border">
            {items.map((i) => (
              <div key={i.key} className="py-6 flex gap-5" data-testid={`cart-item-${i.product_id}`}>
                <Link to={`/product/${i.product_id}`} className="w-24 aspect-[3/4] bg-sand overflow-hidden shrink-0">
                  <img src={i.image} alt={i.name} className="w-full h-full object-cover" />
                </Link>
                <div className="flex-1">
                  <p className="text-[10px] tracking-[0.25em] uppercase text-muted-foreground">{i.brand}</p>
                  <Link to={`/product/${i.product_id}`} className="font-serif text-xl hover:text-wine transition-colors">{i.name}</Link>
                  {i.size && <p className="text-xs text-muted-foreground mt-1">Size {i.size}</p>}
                  <div className="mt-3 flex items-center gap-3">
                    <button onClick={() => updateQty(i.key, i.qty - 1)} data-testid={`qty-minus-${i.product_id}`} className="w-7 h-7 border border-border flex items-center justify-center"><Minus size={12} /></button>
                    <span className="font-mono text-sm w-6 text-center">{i.qty}</span>
                    <button onClick={() => updateQty(i.key, i.qty + 1)} data-testid={`qty-plus-${i.product_id}`} className="w-7 h-7 border border-border flex items-center justify-center"><Plus size={12} /></button>
                  </div>
                </div>
                <div className="text-right flex flex-col justify-between items-end">
                  <button onClick={() => removeItem(i.key)} data-testid={`remove-${i.product_id}`} aria-label="Remove" className="text-muted-foreground hover:text-wine"><X size={16} strokeWidth={1.5} /></button>
                  <p className="font-mono">{inr(i.price * i.qty)}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="bg-sand/60 p-8 h-fit sticky top-28" data-testid="cart-summary">
            <p className="text-[10px] tracking-[0.25em] uppercase text-muted-foreground">Summary</p>
            <div className="mt-5 flex justify-between font-mono text-lg"><span>Subtotal</span><span data-testid="cart-subtotal">{inr(subtotal)}</span></div>
            <p className="mt-3 text-xs text-muted-foreground leading-relaxed">Cloth Cash can be applied at checkout. Delivery is complimentary across India.</p>
            <Link to="/checkout" data-testid="checkout-btn"
              className="mt-8 group w-full bg-ink text-ivory py-4 text-[11px] tracking-[0.25em] uppercase flex items-center justify-center gap-3 hover:bg-wine transition-colors">
              Proceed to Checkout <ArrowRight size={14} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
